import { request } from "./http";

export interface Statement {
  trading_account_id: string;
  date: string;
  starting_balance: string;
  ending_balance: string;
  deposits: string;
  withdrawals: string;
  swaps: string;
  commissions: string;
  pnl_realized: string;
  fills: Array<{
    symbol: string;
    side: string;
    quantity: string;
    price: string;
    commission: string;
    venue: string | null;
    timestamp: string;
  }>;
  ledger: Array<{
    entry_type: string;
    amount: string;
    currency: string;
    note: string | null;
    occurred_at: string;
  }>;
  positions_eod: Array<{ symbol: string; qty: string; avg_entry: string }>;
}

export const statements = {
  get: (trading_account_id: string, date: string) =>
    request<Statement>(`/api/v1/statements?trading_account_id=${trading_account_id}&date=${date}`),
};
